const routes = [
    {
        path: "/faculties",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'faculty_index'
        }
    }
];

export default routes;
